module.exports = __webpack_public_path__ + "img/cancel.c7c01438.svg";